import { useTasksController_ignoreTask } from '@/services/hooks';
import type { IgnoreTaskDto } from '@/services/types';

import { ignoreBody, useMappedMutation } from '../shared/mutation';

import type { IgnoreTaskVariables, UseIgnoreTaskResult } from './types';

function ignoreTaskToApi(variables: IgnoreTaskVariables) {
    const requestBody: IgnoreTaskDto = {
        ignoredUntil: variables.ignoredUntil?.toISOString(),
        ignoredPermanently: variables.ignoredPermanently,
        ignoredReason: variables.ignoredReason,
    };
    return { taskId: variables.taskId, requestBody };
}

export const useIgnoreTask = (): UseIgnoreTaskResult =>
    useMappedMutation(useTasksController_ignoreTask(), ignoreTaskToApi, ignoreBody);
